/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_Index_ErrorInputs */

const id_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesalahan mengambil data`)
};

const ms_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ralat mendapatkan data`)
};

const da_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejl ved hentning af data`)
};

const de_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Abrufen der Daten`)
};

const en_us2_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error fetching data`)
};

const es_es2_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al obtener los datos`)
};

const es_mx2_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al obtener los datos`)
};

const fil_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error sa pagkuha ng data`)
};

const fr_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la récupération des données`)
};

const it_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore nel recupero dei dati`)
};

const hu_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiba az adatok lekérésekor`)
};

const nl_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout bij ophalen van gegevens`)
};

const no_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feil ved henting av data`)
};

const pl_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błąd pobierania danych`)
};

const pt_br2_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao buscar dados`)
};

const pt_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao obter dados`)
};

const ro_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eroare la preluarea datelor`)
};

const fi_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virhe tietojen haussa`)
};

const sv_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fel vid hämtning av data`)
};

const vi_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi khi tải dữ liệu`)
};

const tr_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veri getirilirken hata oluştu`)
};

const cs_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyba při načítání dat`)
};

const bg_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Грешка при извличане на данни`)
};

const ru_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при получении данных`)
};

const uk_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помилка отримання даних`)
};

const ar_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطأ في جلب البيانات`)
};

const hi_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेटा लाने में त्रुटि`)
};

const th_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อผิดพลาดในการดึงข้อมูล`)
};

const ja_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データの取得エラー`)
};

const zh_cn2_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取数据错误`)
};

const zh_hant1_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取得資料錯誤`)
};

const ko_changelog_index_error = /** @type {(inputs: Changelog_Index_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`데이터를 불러오는 중 오류 발생`)
};

/**
* | output |
* | --- |
* | "Error fetching data" |
*
* @param {Changelog_Index_ErrorInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const changelog_index_error = /** @type {((inputs?: Changelog_Index_ErrorInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_Index_ErrorInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_changelog_index_error(inputs)
	if (locale === "ms") return ms_changelog_index_error(inputs)
	if (locale === "da") return da_changelog_index_error(inputs)
	if (locale === "de") return de_changelog_index_error(inputs)
	if (locale === "en-US") return en_us2_changelog_index_error(inputs)
	if (locale === "es-ES") return es_es2_changelog_index_error(inputs)
	if (locale === "es-MX") return es_mx2_changelog_index_error(inputs)
	if (locale === "fil") return fil_changelog_index_error(inputs)
	if (locale === "fr") return fr_changelog_index_error(inputs)
	if (locale === "it") return it_changelog_index_error(inputs)
	if (locale === "hu") return hu_changelog_index_error(inputs)
	if (locale === "nl") return nl_changelog_index_error(inputs)
	if (locale === "no") return no_changelog_index_error(inputs)
	if (locale === "pl") return pl_changelog_index_error(inputs)
	if (locale === "pt-BR") return pt_br2_changelog_index_error(inputs)
	if (locale === "pt") return pt_changelog_index_error(inputs)
	if (locale === "ro") return ro_changelog_index_error(inputs)
	if (locale === "fi") return fi_changelog_index_error(inputs)
	if (locale === "sv") return sv_changelog_index_error(inputs)
	if (locale === "vi") return vi_changelog_index_error(inputs)
	if (locale === "tr") return tr_changelog_index_error(inputs)
	if (locale === "cs") return cs_changelog_index_error(inputs)
	if (locale === "bg") return bg_changelog_index_error(inputs)
	if (locale === "ru") return ru_changelog_index_error(inputs)
	if (locale === "uk") return uk_changelog_index_error(inputs)
	if (locale === "ar") return ar_changelog_index_error(inputs)
	if (locale === "hi") return hi_changelog_index_error(inputs)
	if (locale === "th") return th_changelog_index_error(inputs)
	if (locale === "ja") return ja_changelog_index_error(inputs)
	if (locale === "zh-CN") return zh_cn2_changelog_index_error(inputs)
	if (locale === "zh-Hant") return zh_hant1_changelog_index_error(inputs)
	return ko_changelog_index_error(inputs)
});
export { changelog_index_error as "changelog.index.error" }